

































import Vue from 'vue';
import { Headlines as ArticleHeadlines } from '@root/modules/article/types/article';
import { DataWithHref, Data as HeadlinesData } from '@root/modules/headlines/types/headlines';
import getHeadlineWithHref from '@root/modules/headlines/utils/getHeadlineWithHref';
import ArticleHeadline from './ArticleHeadline.vue';
import getArticleUrl from '@root/modules/article/utils/buildArticleUrl';

interface Methods {
  addClickData: (headline: HeadlinesData, params: Record<string, any>) => Record<string, any>;
  getHeadline: (headline: HeadlinesData) => DataWithHref;
}

interface Computed {
  headlineList: DataWithHref[];
}

interface Props {
  headlines: ArticleHeadlines;
  limit: number;
  start: number;
}

interface Data {
  domains: string | string[];
  locale: string;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    ArticleHeadline,
  },
  props: {
    headlines: {
      type: Array,
      required: true,
    },
    limit: {
      type: Number,
      required: true,
    },
    start: {
      type: Number,
      required: true,
    },
  },
  data() {
    const { domain, locale, temporaryAllowedDomains } = this.$channelConfig('settings');
    const domains = temporaryAllowedDomains ? [...new Set([...temporaryAllowedDomains, domain])] : domain;
    return {
      domains,
      locale,
    };
  },
  computed: {
    headlineList() {
      const headlines = this.headlines.slice(this.start, this.limit).map(headline => this.getHeadline(headline)) || [];
      return headlines;
    },
  },
  methods: {
    addClickData(headline: HeadlinesData, params: Record<string, any>) {
      const clickData: Record<string, any> = {};

      clickData.articleLayout = 'a';
      clickData.listType = params.listType;
      clickData.listPosition = params.listPosition;
      clickData.listArticleId = headline.id;
      clickData.listArticleUrl = getArticleUrl({ article: headline, domain: headline.primaryCategory.channel.url });
      clickData.listArticlePosition = params.listIndex;

      return { ...headline, clickData };
    },
    getHeadline(headline) {
      const fakeDomainEnabled = this.$config.FAKE_DOMAIN_ENABLED;
      return getHeadlineWithHref({ headline, domain: this.domains, fakeDomainEnabled });
    },
  },
});
